'use strict';

outletService.$inject = ["api", "OutletCategory", "OutletHomePage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletService = outletService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function outletService(api, OutletCategory, OutletHomePage) {
    return {
        getCategories: getCategories,
        getTextFields: getTextFields
    };

    function getCategories() {

        return api.outlet.get().$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse, function (i) {
                return OutletCategory.create(i);
            });
        });
    }
    function getTextFields() {
        return api.outletHomePage.get().$promise.then(function (response) {
            return OutletHomePage.create(response);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/outletService.js
// module id = 819
// module chunks = 0